import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ebwob1e8ry: FaireBrandEntity = {
  token: "b_ebwob1e8ry",
  type: "brand",
  name: "Carson Dellosa Education",
  avatarUrl:
    "https://cdn.faire.com/fastly/193f6c554ba4e04c0079b65dcb049400de6e90027ef95196d4a65ec4eed9acb0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a8422c7ae40a748fc59a254937dca819476c1aa2db5522eccb8f923277fe37c6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/193f6c554ba4e04c0079b65dcb049400de6e90027ef95196d4a65ec4eed9acb0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a8422c7ae40a748fc59a254937dca819476c1aa2db5522eccb8f923277fe37c6.jpeg",
  location: "Greensboro, NC, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 14,
  isInsider: true,
  description:
    "At Carson Dellosa, we believe that children learn everywhere, sometimes in the most unexpected places and ways. We create products that inspire these learning moments at school, from home, and everywhere in between.\n\nForty-five years ago, our company was founded by two teachers who made it their mission to create materials that help enhance the learning experience. We understand the educational journey—it’s in our DNA.\n\nWe aim to help educators whenever we can, wherever we can, which is why we provide materials for a variety of subjects, classroom organizational needs, and more.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:31.906Z",
    importedBy: "entity-db-cli",
  },
};
